import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgLoop = function SvgLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75001 6.15728C6.51223 4.35415 8.47305 3.25 11.271 3.25C16.2415 3.25 20.271 7.27943 20.271 12.25C20.271 17.2205 16.2415 21.25 11.271 21.25C7.35118 21.25 4.01846 18.7445 2.78331 15.2499C2.64527 14.8594 2.84997 14.4309 3.24051 14.2929C3.63104 14.1548 4.05954 14.3595 4.19757 14.7501C5.22752 17.6641 8.00662 19.75 11.271 19.75C15.4131 19.75 18.771 16.3921 18.771 12.25C18.771 8.10787 15.4131 4.75 11.271 4.75C8.84832 4.75 7.19404 5.71268 5.54315 7.5H8.00001C8.41422 7.5 8.75001 7.83579 8.75001 8.25C8.75001 8.66421 8.41422 9 8.00001 9H4.75001C3.92157 9 3.25001 8.32842 3.25001 7.5V4.25C3.25001 3.83579 3.5858 3.5 4.00001 3.5C4.41422 3.5 4.75001 3.83579 4.75001 4.25V6.15728Z"
  })));
};

export { SvgLoop as ReactComponent };
//# sourceMappingURL=loop.svg.js.map
